export interface FormVideo {
  id: string
  title: string
  instructor: string
  duration: string
  thumbnail: string
  videoUrl?: string
  description: string
}

export const formVideos: FormVideo[] = [
  {
    id: 'kee-cho-hyung-il-boo-white-belt-form-1',
    title: 'Kee Cho Hyung Il Boo White Belt Requirement Basic Form 1',
    instructor: 'Mark Kanaar',
    duration: '03:37',
    thumbnail:
      'https://images.unsplash.com/photo-1555597673-b21d5c935865?w=800&h=600&fit=crop',
    description:
      'Master Mark S. Kanaar Kee Cho Hyung Il Boo Basic Form 1 White Belt Requirement Che Ko Taekwondo Academy',
  },
  {
    id: 'kee-cho-hyung-ee-boo-form-2',
    title: 'Explanation of Kee Cho Hyung Ee Boo Basic form 2. Front View',
    instructor: 'Mark Kanaar',
    duration: '03:27',
    thumbnail:
      'https://images.unsplash.com/photo-1555597673-b21d5c935865?w=800&h=600&fit=crop',
    description:
      'Master Mark S. Kanaar Che Ko Taekwondo Academy Kee Cho Hyung Ee Boo Basic Form 2 White Belt with Yellow Stripe',
  },
  {
    id: 'kee-cho-hyung-sam-boo-form-3',
    title: 'Break Down for Kee Cho Hyung Sam Boo for AAU Taekwondo',
    instructor: 'Mark Kanaar',
    duration: '07:21',
    thumbnail:
      'https://images.unsplash.com/photo-1555597673-b21d5c935865?w=800&h=600&fit=crop',
    description:
      'Master Mark S. Kanaar Che Ko Taekwondo Academy Grey Wolf Martial Arts Kee Cho Hyung Sam Boo Basic Form 3',
  },
  {
    id: 'pyung-ahn-cho-dan-form-4',
    title: 'Pyung Ahn Cho Dan Form 4',
    instructor: 'Mark Kanaar',
    duration: '06:58',
    thumbnail:
      'https://images.unsplash.com/photo-1555597673-b21d5c935865?w=800&h=600&fit=crop',
    description: 'Master Mark S. Kanaar demonstrates Pyung Ahn Cho Dan',
  },
  {
    id: 'pyung-ahn-ee-dan-form-5',
    title: 'Pyung Ahn Ee Dan Form 5',
    instructor: 'Mark Kanaar',
    duration: '05:28',
    thumbnail:
      'https://images.unsplash.com/photo-1555597673-b21d5c935865?w=800&h=600&fit=crop',
    description: 'Master Mark S. Kanaar demonstrates Pyung Ahn Ee Dan',
  },
  {
    id: 'pyung-ahn-sam-dan-form-6',
    title: 'Pyung Ahn Sam Dan Form 6',
    instructor: 'Mark Kanaar',
    duration: '06:31',
    thumbnail:
      'https://images.unsplash.com/photo-1555597673-b21d5c935865?w=800&h=600&fit=crop',
    description: 'Master Mark S. Kanaar demonstrates Pyung Ahn Sam Dan',
  },
]
